import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleHostedUiCallback } from '@shared/auth/cognito';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function completeSignIn() {
      try {
        const result = await handleHostedUiCallback();
        if (!cancelled) {
          navigate(result.returnTo || '/', { replace: true });
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Unable to complete sign in.');
        }
      }
    }

    void completeSignIn();

    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="auth-page">
      <article className="auth-card">
        <div className="brand auth-brand">
          <div className="brand-mark">S</div>
          <div>
            <div className="brand-title">SURELINC</div>
            <div className="brand-subtitle">CMMC Portal</div>
          </div>
        </div>
        <h1>Completing sign in</h1>
        {!error && <p>Validating your session...</p>}
        {error && (
          <>
            <p className="error-text">{error}</p>
            <a className="primary-button" href="/login">Return to sign in</a>
          </>
        )}
      </article>
    </div>
  );
}
